import { Alert, Button } from "@components";
import { FC, Fragment } from "react"
import { useControllers } from "./useControllers";

export const EmailConfirmScreen: FC = () => {
    
    const { 
        isLoading,
        verifyEmailError,
        handleOtpResend,
    } = useControllers();

    return (
        <div className="flex flex-col justify-center items-center min-h-screen gap-y-4">
            {
                isLoading && <div className="flex justify-center">
                    <span className="loading loading-dots loading-lg" />
                </div>
            }
            {
                verifyEmailError && (
                    <Fragment>
                        <Alert
                            type="error"
                            message={verifyEmailError?.message}
                        />
                        <Button
                            onClick={handleOtpResend}
                            type="button"
                            variant="secondary"
                            className="w-md"
                            disabled={isLoading}
                        >
                            {!isLoading ? "Renvoyer l'OTP" : "Chargement..."}
                        </Button>
                    </Fragment>
                )
            }
        </div>
    )
}
